module.exports = __webpack_public_path__ + "static/media/14UNEP1.c5a99c04.jpg";